export default {
    basePath: "/",
    apiUrl: "http://localhost:5000",
};